import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Page} from '../../../model/page';
import {Section} from '../../section/Section';
import {SergasDevice} from './sergasDevice';

@Injectable({
  providedIn: 'root'
})
export class SergasDeviceService {

  private basePath = "api/v1/sergas_device";

  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  getPage(page= 0, size= 15, sort= "", filter= "") {
    let url = this.basePath;
    let params = new HttpParams();
    params = params.append('page', page.toString())
      .append('size', size.toString())
      .append('sort', sort)
      .append('filter', filter);
    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response as Page )
      .catch(error => this.errorHandler(error));
  }

  getSergasDevice(sergasDeviceId:string): Promise<any>{
    let url = this.basePath + "/" + sergasDeviceId;
    return this.http.get(url)
      .toPromise()
      .then( res => res as SergasDevice)
      .catch( error => this.errorHandler(error) );
  }

  createSergasDevice(sergasDevice: SergasDevice): Promise<any> {
    let url = this.basePath;
    return this.http.post(url, sergasDevice)
      .toPromise()
      .then( res => res as SergasDevice)
      .catch( error => this.errorHandler(error) );
  }

  updateSergasDevice(sergasDevice: SergasDevice): Promise<any> {
    let url = this.basePath + "/" + sergasDevice.sergasDeviceId;
    return this.http.put(url, sergasDevice)
      .toPromise()
      .then( res => res as SergasDevice)
      .catch( error => this.errorHandler(error) );
  }

  deleteSergasDevice(sergasDevice: SergasDevice): Promise<any> {
    let url = this.basePath + "/" + sergasDevice.sergasDeviceId;
    return this.http.delete(url)
      .toPromise()
      .then( res => res as any)
      .catch( error => this.errorHandler(error) );
  }

  getReport(reportParams): Promise<any> {
    let url = this.basePath + "/report";
    return this.http.post(url, reportParams, {responseType: 'blob'})
      .toPromise()
      .then(response => response)
      .catch(error => this.errorHandler(error));
  }
}
